/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type TuberculosisHistoryDtoPreviousTherapySuccessful =
  | (typeof TuberculosisHistoryDtoPreviousTherapySuccessful)[keyof typeof TuberculosisHistoryDtoPreviousTherapySuccessful]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TuberculosisHistoryDtoPreviousTherapySuccessful = {
  YES: 'YES',
  NO: 'NO',
  UNKNOWN: 'UNKNOWN',
} as const;
